module.exports = {"TXTCLI_In_N0_min":{"id":"TXTCLI_In_N0_min","defaultMessage":"Em {0} minutos"},"TXTCLI_Now":{"id":"TXTCLI_Now","defaultMessage":"Agora"}}